import React from "react";
import { IconProps, Icon } from "@chakra-ui/react";

const DeleteIcon = ({ ...props }: IconProps) => (
  <Icon
    w={6}
    h={6}
    stroke="red.500"
    viewBox="0 0 24 24"
    {...props}
    fill="none"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M4 7h16M10 11v6M14 11v6M5 7l1 12a2 2 0 002 2h8a2 2 0 002-2l1-12M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3"
    />
  </Icon>
);

export default DeleteIcon;
